module.exports = __webpack_public_path__ + "media/images/flags/64/Algeria-3957980a9e1db9916ba1d279c00c59bb.png";